var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTipsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 40,
    viewBox: "0 0 53 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0701 33.5099H6.17006C3.63006 33.5099 1.56006 31.4499 1.56006 28.8999V5.97988C1.56006 3.43988 3.62006 1.37988 6.16006 1.37988H22.0601C24.6001 1.37988 26.6601 3.43988 26.6601 5.97988V33.5099",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.67 35.8099V5.97988C26.67 3.43988 28.73 1.37988 31.27 1.37988H47.1701C49.7101 1.37988 51.77 3.43988 51.77 5.97988V28.8999C51.77 31.4399 49.71 33.5099 47.16 33.5099H31.27",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6701 38.3398H6.17006C3.63006 38.3398 1.56006 36.2798 1.56006 33.7298V25.0598",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.77 26.8599V33.7299C51.77 36.2699 49.71 38.3399 47.16 38.3399H26.67",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6001 33.5098H22.0701C24.6101 33.5098 26.6701 35.5698 26.6701 38.1098C26.6701 35.5698 28.7301 33.5098 31.2701 33.5098",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1801 8.38989H44.83",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30005 8.38989H19.95",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1801 13.8398H44.83",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30005 13.8398H19.95",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1801 19.2898H44.83",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.24 25.0598H44.83",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30005 19.2898H19.95",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30005 25.0598H19.95",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1801 26.63C34.0472 26.63 34.7501 25.9271 34.7501 25.06C34.7501 24.1929 34.0472 23.49 33.1801 23.49C32.313 23.49 31.6101 24.1929 31.6101 25.06C31.6101 25.9271 32.313 26.63 33.1801 26.63Z",
    fill: "#00C9B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipsIcon);
export default __webpack_public_path__ + "static/media/tips-icon.91885b53330cd88fde92054c3e0171b8.svg";
export { ForwardRef as ReactComponent };